import { observer } from 'mobx-react';
import { autoinject, SubTopBar, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { PodChartsDashboard } from './PodChartsDashboard';

export interface IPodChartsViewProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class PodChartsView extends React.Component<IPodChartsViewProps> {
    public render() {
        return (
            <>
                <Title>Pod Charts</Title>

                <SubTopBar>
                    <span className="nav-link fw-bold d-inline-block">CPU &amp; Memory Over Time</span>
                </SubTopBar>

                <PodChartsDashboard />
            </>
        );
    }
}
